import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import { useTranslation } from "../../../../../contexts/translation-context.js";
import { st, classes } from "../FileUpload.st.css";
import FileUploadIndicator from "./FileUploadIndicator.js";
const File = ({
  file,
  onDeleteClick,
  dataHook,
  focusFile = false,
  role,
  deleteButtonRef: deleteButtonRefFromProps,
  ...rest
}) => {
  const { t } = useTranslation();
  const localDeleteButtonRef = useRef(null);
  const deleteButtonRef = deleteButtonRefFromProps || localDeleteButtonRef;
  useEffect(() => {
    if (focusFile) {
      deleteButtonRef?.current?.focus();
    }
  }, [deleteButtonRef]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: st(classes.fileContainer, {
        error: file.state === "error"
      }),
      "aria-describedby": rest["aria-describedby"],
      "aria-label": file.file.name,
      role,
      children: [
        /* @__PURE__ */ jsx("div", { "data-hook": dataHook, className: classes.file, title: file.file.name, children: file.file.name }),
        /* @__PURE__ */ jsx("div", { className: classes.fileUploadIndicator, children: /* @__PURE__ */ jsx(
          FileUploadIndicator,
          {
            deleteButtonRef,
            state: file.state,
            onDeleteClick,
            "aria-label": t("file-upload.delete-file.aria-label")
          }
        ) })
      ]
    }
  );
};
export {
  File as default
};
//# sourceMappingURL=File.js.map
